import { MultiImagePicker } from 'app/design/primitives/multi-image-picker';
import { useFormContext } from 'app/hooks/form';
import { useScopedTranslation } from 'app/hooks/i18n';
import { usePopularItemsByCategory } from 'app/network/category';
import type { CreateListingDTO, NewListingSource } from 'app/types/listing';
import { useTrackNewListingSource } from 'app/network/listing';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
// import type { schema } from '../index';
import { ListingType } from 'app/types/listing';
import { useUISize } from 'app/utils/web-helpers';
import { type ImagePickerAsset } from 'expo-image-picker';

export function GeneralSection({
  isAnalyzing = false,
  newListingSource,
  onChange,
}: {
  isAnalyzing?: boolean;
  newListingSource?: NewListingSource;
  onChange?: (images: ImagePickerAsset[]) => void;
}) {
  const { t } = useScopedTranslation();
  const isSmallUI = useUISize().isSmallUI;
  const { data: quickOffersAvailable } = usePopularItemsByCategory();

  // const { control, setValue, watch } = useFormContext<yup.InferType<typeof schema>>();
  const { control, setValue, watch } = useFormContext<CreateListingDTO>(); // Workaround for https://github.com/react-hook-form/react-hook-form/issues/12916

  const watchedType = watch('type');

  useEffect(() => {
    if (watchedType === ListingType.request) {
      setValue('picture', null);
      setValue('pictures', []);
    }
  }, [setValue, watchedType]);

  useEffect(() => {
    if (quickOffersAvailable === undefined) return;
    if (quickOffersAvailable.length === 0) {
      if (!watchedType) {
        setValue('type', ListingType.offer);
      }
    }
  }, [quickOffersAvailable, setValue, watchedType]);

  const trackNewListingSource = useTrackNewListingSource();
  useEffect(() => {
    if (newListingSource) {
      trackNewListingSource(newListingSource);
    }
  }, [newListingSource, trackNewListingSource]);

  return (
    <Controller
      {...{ control }}
      name="pictures"
      render={({ field }) => (
        <MultiImagePicker
          disabled={isAnalyzing}
          onChange={(images) => {
            field.onChange(images);
            onChange?.(images);
          }}
          title={t('generalSection.addPictures')}
          images={field.value ?? []}
          thumbnailSize={isSmallUI ? 90 : 140}
          // withInlinePicker not needed here since we aren't in a Modal.
        />
      )}
    />
  );
}
